import Component from 'flarum/common/Component';
import UserEventCardComponents from './UserEventCardComponents';
export default class getUserLabelComponents extends Component {
  oninit(vnode) {
    super.oninit(vnode);
  }
  view() {
    this.className = this.attrs.className;
    this.userData = this.attrs.userData;
    this.callback = this.attrs.callback || function () {};
    this.param = this.attrs.param || {};
    this.cardData = this.attrs.cardData || null;
    this.showAvatar = this.attrs.showAvatar || true;
    this.removable = this.attrs.removable || false;
    this.identifier = this.attrs.identifier || "a";
    const userData = this.userData;
    if (userData === null) {
      return null;
    }
    const cardData = this.cardData;
    const callback = this.callback;
    const param = this.param;
    const userID = userData.id();
    const cardID = cardData ? cardData.id() : "nocard";
    const username = userData.displayName() || '?';
    const avatarUrl = userData.avatarUrl();
    let content = "";
    if (this.showAvatar) {
      if (avatarUrl) {} else {
        content = username.charAt(0).toUpperCase();
      }
    }
    const userNickName = userData.attribute("displayName");
    const style = "background:" + userData.color();
    const containerID = "userLabelContainer" + userID + "_" + cardID + "_" + this.identifier;
    if (this.identifier === "a") {
      // console.log("c",cardID,userID);
    }
    return m("block", {
      class: "userLabelContainer",
      id: containerID
    }, this.showAvatar ? [avatarUrl ? [m("img", {
      src: avatarUrl,
      className: "userLabelAvatar"
    })] : [m("block", {
      class: "userLabelAvatar",
      style: style
    }, content)]] : [], m("span", {
      class: "username"
    }, userNickName), this.cardData ? [m(UserEventCardComponents, {
      cardData: cardData
    })] : [], this.removable ? [m("i", {
      class: "fa-solid fa-xmark",
      style: "margin-left: 4px;color:indianred;cursor:pointer",
      onclick: () => {
        // console.log(containerID);
        $("#" + containerID).remove();
        callback(param);
      }
    })] : []);
  }
}
flarum.reg.add('ziiven-ziven-core', 'common/components/getUserLabelComponents', getUserLabelComponents);